import { render } from "./Sponsor.vue?vue&type=template&id=d3e9e76e&scoped=true"
import script from "./Sponsor.vue?vue&type=script&lang=js"
export * from "./Sponsor.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d3e9e76e"

export default script